export default {
  setEcotronList(state, ecotronList) {
    state.ecotronList = ecotronList;
  },

  setEcotronPagination(state, pagination) {
    state.ecotronPagination = pagination;
  },

  setEcotronCurrent(state, ecotronCurrent) {
    state.ecotronCurrent = ecotronCurrent;
  },

  setEcotronLoading(state, loading) {
    state.ecotronLoading = loading;
  }
};
